import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useBusyBlockerContext } from "../contexts/busy-blocker-context";
import { useAppContext } from "./useAppContext";
import { useClient } from "./useClient";
import { useDefinition } from "./useDefinition";
import { useSelectedProductAttribute } from "./useSelectedProductAttribute";

export const useOptionsAndAlternatives = () => {
	const definition = useDefinition();

	const client = useClient();

	const { reactQueryNoReloadOptions } = useAppContext();

	const selectedProductAttribute = useSelectedProductAttribute();
	const { busyBlocker } = useBusyBlockerContext();

	return useQuery<eXpress.core.IOptionsResult>({
		// eslint-disable-next-line @tanstack/query/exhaustive-deps
		queryKey: [
			"use-options-and-alternatives",
			definition?.product.predefinedName,
			definition?.product.code,
			selectedProductAttribute,
			definition?.product.aspectRatio,
		],
		queryFn: () =>
			definition
				? busyBlocker.during(
						client.getOptionsAndAlternativesAsync(
							definition.product.predefinedName,
							definition.product.code,
							selectedProductAttribute,
							definition.product.aspectRatio || undefined,
						),
				  )
				: Promise.reject(
						new Error("Cannot fetch options and alternatives without a definition"),
				  ),
		// query will not execute until the definition exists
		enabled: !!definition,
		placeholderData: keepPreviousData,
		...reactQueryNoReloadOptions,
	});
};
